import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import WaitingApproval from './pages/WaitingApproval';
import CompleteProfile from './pages/CompleteProfile';
import AdminUsers from './pages/admin/Users';
import AdminTenants from './pages/admin/Tenants';
import AdminDevices from './pages/admin/Devices';
import AdminLogs from './pages/admin/Logs';
import AdminAlerts from './pages/admin/Alerts';
import AdminContacts from './pages/admin/Contacts';
import AdminPrices from './pages/admin/Prices';
import AdminSettings from './pages/admin/Settings';
import AuthCallback from './pages/auth/Callback';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route 
              path="/login" 
              element={
                <ProtectedRoute allowUnauthenticated>
                  <Login />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/register" 
              element={
                <ProtectedRoute allowUnauthenticated>
                  <Register />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute requiredStatus="active">
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/waiting-approval" 
              element={
                <ProtectedRoute requiredStatus="pending_approval">
                  <WaitingApproval />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/complete-profile" 
              element={
                <ProtectedRoute>
                  <CompleteProfile />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/users" 
              element={
                <ProtectedRoute requiredRole="superadmin" requiredStatus="active">
                  <AdminUsers />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/tenants" 
              element={
                <ProtectedRoute requiredRole="superadmin" requiredStatus="active">
                  <AdminTenants />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/devices" 
              element={
                <ProtectedRoute requiredRole="superadmin" requiredStatus="active">
                  <AdminDevices />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/logs" 
              element={
                <ProtectedRoute requiredRole="superadmin" requiredStatus="active">
                  <AdminLogs />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/alerts" 
              element={
                <ProtectedRoute requiredRole="superadmin" requiredStatus="active">
                  <AdminAlerts />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/contacts" 
              element={
                <ProtectedRoute requiredRole="superadmin" requiredStatus="active">
                  <AdminContacts />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/prices" 
              element={
                <ProtectedRoute requiredRole="superadmin" requiredStatus="active">
                  <AdminPrices />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/settings" 
              element={
                <ProtectedRoute requiredRole="superadmin" requiredStatus="active">
                  <AdminSettings />
                </ProtectedRoute>
              } 
            />
            <Route path="/auth/callback" element={<AuthCallback />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
